import axios from "axios";
import { apiAddress } from "../settings";

class RoomAPI {
  apiURL = apiAddress + "/room/api/";

  getParts() {
    return axios
      .get(this.apiURL + "parts/")
      .then(function (response) {
        return {
          success: true,
          data: response.data,
        };
      })
      .catch(function (error) {
        return {
          success: false,
          error: error.response,
        };
      });
  }
}

export default RoomAPI;
